// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let RivalIQ;
if (typeof window === 'undefined') {
    RivalIQ = {
        utils: {}
    };
} else {
    RivalIQ = window.RivalIQ;
    RivalIQ.module('utils', function () {});
}

(function () {

    'use strict';

    const branding = {};

    /**
     * The types of branding.
     **/
    branding.types = {
        DEFAULT: 'defaultBranding',
        CUSTOM: 'customBranding'
    };

    const brandRetrievalStrategies = {};

    /**
     * Gets the default branding from settings.
     **/
    brandRetrievalStrategies[branding.types.DEFAULT] = function () {
        return RivalIQ.models.Brand.createFromSettings(branding.types.DEFAULT, RivalIQ.settings.accountSettings);
    };

    /**
     * Gets the custom branding from settings.
     **/
    brandRetrievalStrategies[branding.types.CUSTOM] = function (landscapeId) {

        let customBranding = null;
        let landscapeSettings = RivalIQ.settings.activeLandscapeSettings;

        if (landscapeId) {

            for (let temp, i = 0, a = RivalIQ.state.user.get('landscapes'), l = a.length; i < l; i++) {

                temp = a[i];

                if (temp.id === landscapeId) {

                    landscapeSettings = temp.settings;
                    break;
                }
            }
        }

        // we only create the custom branding model if branding exists for this landscape
        if (landscapeSettings && landscapeSettings.brandCustomization) {
            customBranding = RivalIQ.models.Brand.createFromSettings(branding.types.CUSTOM, landscapeSettings);
        }

        return customBranding;
    };

    /**
     * Gets branding from settings by type.
     **/
    branding.getBranding = function (brandingType, landscapeId) {

        const strategy = brandRetrievalStrategies[brandingType];
        return (strategy ? strategy(landscapeId) : null);
    };

    /**
     * Gets the active branding type for this landscape.
     **/
    branding.getActiveBrandingType = function () {

        return RivalIQ.state.landscape.get('activeBranding');
    };

    /**
     * Gets the active branding type for this landscape or default.
     **/
    branding.getActiveBrandingTypeOrDefault = function () {

        const brandingType = branding.getActiveBrandingType();
        return (brandingType || branding.types.DEFAULT);
    };

    branding.overrideReportStyles = function (branding) {

        const isDefaultLogo = branding.isDefaultLogo();

        // override images
        let largeLogo = null;
        let smallLogo = null;

        if (isDefaultLogo) {

            largeLogo = RivalIQ.apps.Reports.models.Slide.brandImages.getDefaultLarge();
            smallLogo = RivalIQ.apps.Reports.models.Slide.brandImages.getDefaultSmall();
        } else {

            largeLogo = branding.get('logo');
            smallLogo = largeLogo; // NOTE: small logo IS large logo
        }

        RivalIQ.apps.Reports.models.Slide.customizeBrandImages(largeLogo, smallLogo);

        const styles = RivalIQ.apps.Reports.models.Slide.customizeStyles(!isDefaultLogo);
        return styles;
    };

    branding.getBrandingColors = function (branding) {
        const brandColors = branding.colors;

        // Note, indices here are intentional, see the DEFAULT_VARIABLE_NAMES
        // array above
        return {
            title: [brandColors[0]],
            subtitle: [brandColors[1]],
            primary: [brandColors[3]],
            secondary: [brandColors[2]],
            pie: brandColors.slice(4)
        };
    };

    // NOTE export the results, for both server and client
    if (typeof window === 'undefined') {

        // NOTE for the server, only expose types, not the entirety of the branding utilities
        module.exports.types = branding.types;
    } else {

        RivalIQ.utils.branding = branding;
    }

})();
